<div class="modal-content">

  <div class="modal-header">
    <h3 class="modal-title">
      {{ 'Participate in election' | translate }} {{ election.title }}
    </h3>
  </div>

  <div class="modal-body">

   <p>
     {{ 'Confirm that you want to sign up for this election' | translate }}
   </p>

    <div class="row">

      <div *ngIf="election.avatarUri" class="col election-image-wrapper">
        <img class="img-fluid" [src]="election.avatarUri" />
      </div>

      <div class="col">

        <h5>{{ electionService.getTranslatedTitle(election) }}</h5>

        <p *ngIf="election.year">
          {{ 'Year' | translate }}: {{ election.year}}
        </p>

        <div class="description" [innerHTML]="electionService.getTranslatedDescription(election)"></div>

        <div *ngIf="electionService.getTranslatedExtraInfo(election)" class="extraInfo mt-3" [innerHTML]="electionService.getTranslatedExtraInfo(election)"></div>

        <p class="font-weight-bold mt-3">
          {{ 'Choose your participation region' | translate }}*
        </p>

        <ng-container>
          <div class="gap-3 d-flex flex-column">
            <button class="btn mt-3 d-block w-100" [ngClass]="{'btn-primary': areaId == area.id,'btn-secondary' : areaId != area.id}" *ngFor="let area of election.areas" (click)="setAreaId(area.id!)">
              {{ area.name }}
            </button>
          </div>
        </ng-container>

      </div>

    </div>

  </div>

  <div class="modal-footer d-flex justify-content-between">

    <button class="btn btn-secondary" type="button" (click)="activeModal.close(false)">
      {{ 'Cancel' | translate }}
    </button>

    <button (click)="signUp()" type="button" [attr.disabled]="!valid() ? true : null" class="btn btn-primary">
      {{ 'Sign up' | translate }}
    </button>

  </div>

</div>
